import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Summary } from 'src/pages/Prioritize/Participate/Content'
import DateTime from 'src/models/DateTime';

export class Content extends React.Component {

  getCardContent = () => {
    const { event } = this.props;
    if (!!_.get(event, 'collection.name')) {
      return event.collection.name;
    } else {
      return event.name;
    }
  }

  getEventTime = (time) => {
    const now = DateTime.now();
    const duration = DateTime.duration(now.diff(moment.unix(time)));
    const weeks = duration.asWeeks();
    if (weeks > 2) {
      return time.format('MMM Do YYYY');
    } else {
      return time.fromNow();
    }
  }

  render() {
    const { event } = this.props
    const defaultObj = {}
    const { collection = defaultObj, name, title, created_on, end_on } = event
    const { stats = defaultObj } = collection
    const { contributed_percent = 0, total_activities = 0 } = stats

    const start = event.schedule?.voting?.start_time || created_on
    const end = event.schedule?.voting?.end_time || end_on
    const text = name || title

    const collectionName = event.collection?.name
    const creatorName = event.hero?.display_name || event.hero?.email || event.creator?.name || event.creator?.email;

    return (
      <>
        <div className="date-notification">
          <div className="date-notification-left">
            <Calendar date={start} />
            <div>
              {!event.user_created && <Hero creator={creatorName} date={start} />}
              <RemainingTime end_date={end} />
              {collectionName && <div className="card-group-title">{collectionName}</div>}
              <div className="card-title">{text}</div>
            </div>
          </div>

          <div className='summary_container'>
            {event.collection_type === 'prioritize' ? (
              <>
                <Summary title='PARTICIPATION' score={event.stats.participant} />
                <div className="vertical_divider" />
                <Summary title='COMPLETED' score={event.stats.participant > 0 ? `${(event.stats.completed / event.stats.participant * 100).toFixed(0)}%` : "-"} />
              </>
            ) : (
                <>
                  <Summary title='PARTICIPATION' score={`${contributed_percent}%`} />
                  <div className="vertical_divider" />
                  <Summary title='ACTIVITY' score={total_activities} />
                </>
              )}
          </div>
        </div>
      </>
    );
  }
}

const RemainingTime = ({ end_date }) => {
  const end_dt = (typeof end_date === 'number') ? moment.unix(end_date) : moment(end_date);

  let remaining = null;

  if (end_dt.isAfter(moment())) {
    remaining = end_dt.isAfter(moment().add(14, 'days')) ? `Ending ${end_dt.format("MMM D")}` : `Ending ${end_dt.fromNow()}`;
  } else {
    remaining = end_dt.isBefore(moment().subtract(7, 'days')) ? `Completed ${end_dt.format("MMM D")}` : `Completed ${end_dt.calendar()}`;
  }

  return end_date ?
    (
      <span style={{ color: 'red', fontSize: '12px' }}>{remaining}</span>
    ) : (
      <></>
    )
}

const Hero = ({ creator }) => {
  return (
    <span style={{ fontSize: '12px' }}>{creator}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
  )
}

const Calendar = ({ date }) => {

  const moment_dt = (typeof date === 'number') ? moment.unix(date) : moment(date);

  return (
    <div className="calendar-container">
      <div className="month">
        {moment_dt.format('MMMM')}
      </div>
      <div className="day">
        <div className="number">{moment_dt.date()}</div>
        <div className="week_day">{moment_dt.format('dddd')}</div>
      </div>
    </div>
  )
}